module.exports = __webpack_public_path__ + "static/media/transferencias_viejo.91408d54.svg";